import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { createApi } from 'ReduxHelpers';
import { type SelfRegisterParams } from './TuitionAndRegistration.types';

export const selfRegisterApi = createApi('SelfRegister', {
    ...getBackRoyalApiBaseConfig('SelfRegister'),
    endpoints: builder => ({
        selfRegister: builder.mutation<unknown, SelfRegisterParams>({
            query: params => ({
                url: 'user_actions/admission_offer/self_register',
                method: 'POST',
                body: params,
            }),
        }),
    }),
});
